<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="24" :md="22" :lg="20" :xl="16">
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
            size="large"
        >
          <el-row :gutter="10">
            <el-col :span="24" :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <el-form-item label="Viloyat" prop="selectedRegion">
                <el-select class="form-input" v-model="selectedRegion" size="large" @change="getDistricts"
                           style="margin-right: 10px"
                           placeholder="Viloyat tanlang">
                  <el-option v-for="region in regions" :value="region.id" :label="region.title"
                             :key="region.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <el-form-item label="Tuman" prop="districtId">

                <el-select class="form-input" v-model="form.districtId" size="large" clearable
                           placeholder="Tuman tanlang">
                  <el-option v-for="district in districts" :value="district.id" :label="district.title"
                             :key="district.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <el-form-item label="Joylashuv" prop="nearby">
                <el-input placeholder="Joylashuv" v-model="form.nearby" type="text"/>
              </el-form-item>
            </el-col>

            <el-col :span="24" :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <el-form-item label="Mas'ul shaxs" prop="responsiblePerson">
                <el-input placeholder="Mas'ul shaxs" v-model="form.responsiblePerson" type="text"/>
              </el-form-item>
            </el-col>
            <el-col :span="24" :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
              <el-form-item label="Sana" prop="date">
                <el-date-picker style="width: 100%" format="YYYY-MM-DD"
                                value-format="YYYY-MM-DD" placeholder="Sana" v-model="form.date"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="()=>this.$router.go(-1)">Orqaga</el-button>
                <el-button class="custom-btn" type="primary" @click="onSubmit">Saqlash</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";

export default {
  name: "ForumForm",
  data() {
    return {
      loading: false,
      editId: null,
      selectedRegion: null,
      regions: [],
      districts: [],
      form: {
        date: null,
        districtId: null,
        responsiblePerson: null,
        nearby: null
      },
      rules: {
        date: [
          {required: true, message: "Majburiy maydon", trigger: 'change'}
        ],
        districtId: [
          {required: true, message: "Majburiy maydon", trigger: 'change'}
        ],
        responsiblePerson: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
        nearby: [
          {required: true, message: "Majburiy maydon", trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    getForum() {
      this.loading = true
      this.$http.get(`api/v2/info/forum/${this.editId}`).then(({data}) => {
        for (const key in Object.keys(this.form)) {
          this.form[key] = data[key]
        }
        this.form = data
      }).catch(({response}) => {
        ElNotification.error({
          message: response.data.message || "Ma'lmumot yuklasda xatolik sodir bo'ldi!"
        })
      }).finally(() => {
        this.loading = false
      })
    },
    getRegions() {
      this.regionsLoading = true
      this.$http.get('/api/v1/regions').then(({data}) => {
        this.regions = data.regions
      }).catch(() => {

      }).finally(() => {
        this.regionsLoading = false
      })
    },
    getDistricts() {
      this.districtsLoading = true
      this.districts = []
      this.form.districtId = null
      this.$http.get('/api/v1/districts', {
        params: {
          region_id: this.selectedRegion
        }
      }).then(({data}) => {
        this.districts = data.districts
      }).catch(() => {

      }).finally(() => {
        this.districtsLoading = false
      })
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;

          let http;

          const formData = {...this.form}

          if (this.editId) {
            http = this.$http.put(`/api/v2/info/forum/${this.editId}`, formData);
          } else {
            http = this.$http.post('/api/v2/info/forum', formData);
          }


          http.then(() => {
            ElNotification({
              title: 'Tabriklaymiz',
              message: 'Muvafaqiyatli saqlandi',
              type: 'success',
            })
            this.$router.go(-1)
          }).catch(({response}) => {
            ElNotification({
              title: 'Xatolik',
              message: response.data.message || "Iltimos, qayta urinib ko'ring.",
              type: 'error',
            })
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
  },
  mounted() {
    this.getRegions();
    if (this.$route.params.id) {
      this.editId = this.$route.params.id
      this.getForum()
    }
  }
}
</script>

<style scoped>
.form-input {
  width: 100%;
}
</style>
